<template>
    <div>
        <div class="el-table el-table--fit el-table--border inner-table"
            style="border-top: none !important; border-left: none !important">
            <div class="el-table__body-wrapper">
                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                    <tbody>
                        <tr>
                            <td colspan="6" style="position: relative;">
                                <span
                                    style="display: inline-block;margin-left: 45%;color: #333333; font-weight: bold">投标/响应文件</span>
                                <el-button v-if="canEdit == 1" style="position: absolute;right: 5px;"
                                    @click="add()">添加标包</el-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <el-form :model="vo" class="el-form wflow-busiform">
            <div class="el-table el-table--fit el-table--border"
                style="border-top: none !important;border-left: none !important;">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body listTable">
                        <tbody>
                            <!-- <tr>
                                <td colspan="6" style="position: relative;">
                                    <span style="display: inline-block;margin-left: 45%;color: #333333; font-weight: bold">投标/响应文件</span>
                                    <el-button v-if="canEdit==1" style="position: absolute;right: 5px;" @click="add()">添加标包</el-button>
                                </td>
                            </tr> -->
                            <template v-for="(item, index) in vo.passenger.tbItemList">
                                <tr :key="index + '-index'">
                                    <td class="el-table__cell tdcont tdw83" colspan="6">
                                        <span>标包信息{{ index + 1 }}</span>
                                        <el-button v-if="canEdit == 1"
                                            style="position: absolute;right: 5px;color: #f67f6c;" type="text"
                                            @click="deleteBb(index)">删除标包</el-button>
                                    </td>
                                </tr>
                                <tr :key="index + '-first'">
                                    <td ref="tdlbl_标包号" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'flSubject'" class="field">标段号</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="5">
                                        <form-item ref="sectionNumber"
                                            :field="{ 'defaultValue': null, 'elementCanEdit': '{${curTN.tnCanEdit}}', 'elementCssHeight': null, 'elementCssWidth': null, 'elementFormatter': null, 'elementReadonly': 0, 'elementType': 'input', 'emptyMessage': '请输入标段号', 'errorMessage': null, 'formTdAlign': 'text-left', 'formTdColspan': 0, 'isRequired': 1, 'onClickEvent': null, 'passenger': {}, 'propComment': '标段号', 'propName': 'sectionNumber', 'propType': 'String', 'textFormatter': 'textfield', 'valueMaxLength': null, 'valueMinLength': null, 'model': 'item.sectionNumber', 'option': [], 'autocomplete': 'off', 'dialog': 0, 'showWordLimit': false }"
                                            :vo="item" :can-edit="canEdit" />
                                    </td>
                                </tr>
                                <tr :key="index + '-second'">
                                    <td ref="tdlbl_标包文件获取人数" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'flSubject'" class="field">中标/成交文件电子档</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="5">
                                        <div v-if="canEdit" @click="uploadChange(item)">
                                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="附件">
                                                <!-- <div v-if="(item.passenger.attachments && item.passenger.attachments.length > 0)" -->
                                                <div v-for="item2 in getAttachments(item.passenger.attachments, '中标/成交文件')"
                                                    :key="item2.id" class="attachment-link-wrapper">
                                                    <el-link :title="item2.fileName" class="attachment-link"
                                                        @click="download(item2)">
                                                        {{ truncateFileName(item2.fileName) }}
                                                    </el-link>
                                                    <span v-if="canEdit" class="remove-button"
                                                        style="color: red;    margin-left: 10px;"
                                                        @click="handleRemove(item2, item)">
                                                        x
                                                    </span>
                                                </div>
                                                <el-upload ref="uploadRef" class="upload-demo" action="#"
                                                    :on-change="fileChange" :auto-upload="false"
                                                    :on-remove="handleRemove" :multiple="true"
                                                    :file-list="item.passenger.attachments" :show-file-list="false">
                                                    <div style="color:#409eff;">上传附件</div>

                                                </el-upload>
                                            </ValidationProvider>
                                        </div>
                                        <div v-else @click="uploadChange(item)">
                                            <div v-for="item2 in getAttachments(item.passenger.attachments, '中标/成交文件')"
                                                :key="item2.id" class="attachment-link-wrapper">
                                                <el-link :title="item2.fileName" class="attachment-link"
                                                    @click="download(item2)">
                                                    {{ truncateFileName(item2.fileName) }}
                                                </el-link>
                                                <span v-if="canEdit" class="remove-button"
                                                    style="color: red;    margin-left: 10px;"
                                                    @click="handleRemove(item2, item)">
                                                    x
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr :key="index + '-third'">
                                    <td ref="tdlbl_标包文件获取人数" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'flSubject'" class="field">非中标/成交文件电子档</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="5">
                                        <div v-if="canEdit" @click="uploadChange2(item)">
                                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="附件">
                                                <!-- <div v-if="(item.passenger.attachments1 && item.passenger.attachments1.length > 0)" -->
                                                <div v-for="item3 in getAttachments(item.passenger.attachments, '非中标/成交文件')"
                                                    :key="item3.id" class="attachment-link-wrapper">
                                                    <el-link :title="item3.fileName" class="attachment-link"
                                                        @click="download(item3)">
                                                        {{ truncateFileName2(item3.fileName) }}
                                                    </el-link>
                                                    <span v-if="canEdit" class="remove-button"
                                                        style="color: red;    margin-left: 10px;"
                                                        @click="handleRemove2(item3, item)">
                                                        x
                                                    </span>
                                                </div>
                                                <el-upload ref="uploadRef" class="upload-demo" action="#"
                                                    :on-change="fileChange2" :auto-upload="false"
                                                    :on-remove="handleRemove2" :multiple="false"
                                                    :file-list="item.passenger.attachments" :show-file-list="false">
                                                    <div style="color:#409eff;">上传附件</div>

                                                </el-upload>
                                            </ValidationProvider>
                                        </div>
                                        <div v-else @click="uploadChange2(item)">
                                            <div v-for="item3 in getAttachments(item.passenger.attachments, '非中标/成交文件')"
                                                :key="item3.id" class="attachment-link-wrapper">
                                                <el-link :title="item3.fileName" class="attachment-link"
                                                    @click="download(item3)">
                                                    {{ truncateFileName2(item3.fileName) }}
                                                </el-link>
                                                <span v-if="canEdit" class="remove-button"
                                                    style="color: red;    margin-left: 10px;"
                                                    @click="handleRemove2(item3, item)">
                                                    x
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>

    </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        module: { type: String, default: null },
        baseUrl: { type: String, default: null },
        listName: { type: String, default: null },
        isHttp: { type: Boolean, default: true }
    },
    data() {
        return {
            moduleInfo: {},
            updated: true,
            uploadId: '', // 当前上传行id
            updated2: true,
            uploadId2: '' // 当前上传行id
        }
    },
    computed: {

    },
    watch: {
        'vo.passenger.tbItemList': {
            handler(newVal, oldVal) {
                console.log(newVal, oldVal, 'newVal, oldVal')
            },
            deep: true
        }

    },
    created() {

    },
    beforeDestroy() {

    },
    mounted() {
        this.moduleInfo = {
            delUrl: '/' + this.baseUrl + '/' + this.module + '/delete',
            addNewUrl: '/' + this.baseUrl + '/' + this.module + '/addNew',
            insertUrl: '/' + this.baseUrl + '/' + this.module + '/insert',
            moduleCode: this.module,
            updateUrl: '/' + this.baseUrl + '/' + this.module + '/update',
            listDataUrl: '/' + this.baseUrl + '/' + this.module + '/listdata',
            getByIdUrl: '/' + this.baseUrl + '/' + this.module + '/getById',
            querydata: '/' + this.baseUrl + '/' + this.module + '/querydata'
        }
    },
    methods: {
        getAttachments(arr, type) {
            let attachments = []
            arr.forEach(item => {
                if (item.fileType == type) { attachments.push(item) }
            })
            return attachments
        },
        add() {
            this.$http({
                url: this.moduleInfo.addNewUrl,
                method: 'post'
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    res.body.vo.passenger.attachments = []
                    res.body.vo.passenger.attachments1 = []
                    this.vo.passenger.tbItemList.push(res.body.vo)
                }
            })
        },
        deleteBb(index) {
            this.vo.passenger.tbItemList.splice(index, 1)
        },
        // add() {
        //     this.vo.passenger.tbItemList.push({
        //         'sectionNumber': '',
        //         'notificationDate': '',
        //         'passenger': {
        //             attachments: [],
        //             attachments1: []
        //         }

        //     })
        // },
        uploadChange(row) {
            this.uploadId = row.id
        },
        truncateFileName(fileName) {
            // 这里只是一个简单的示例，你可以根据需要调整逻辑
            const maxLength = 20 // 你可以设置你想要的最大长度
            if (fileName.length > maxLength) {
                return fileName.substring(0, maxLength) + '...'
            }
            return fileName
        },
        fileChange(files, fileList) {
            if (fileList.length > 0) {
                this.uploadAttach([files])

                console.log(files, fileList)
            }
        },
        uploadAttach(fileList) {
            const uploadId = this.uploadId
            fileList.forEach((item) => {
                const fd = new FormData()
                fd.append('file', item.raw)
                fd.append('module', this.module)
                fd.append('busiDataId', uploadId)
                fd.append('attachsType', '中标/成交文件')
                fd.append('clientType', 'uploader')
                fd.append('attachsName', item.name)
                this.$http({
                    method: 'post',
                    url: '/' + this.baseUrl + '/' + this.module + '/upload',
                    data: fd
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.vo.passenger.tbItemList.forEach((i) => {
                            if (i.id === uploadId) {
                                // 如果attachments数组还不存在，则创建它
                                if (!i.passenger.attachments) {
                                    this.$set(i.passenger, 'attachments', [{}])
                                }
                                i.invoiceId = res.body.invoiceId
                                // i.passenger.attachments = [...res.body.uploadAttachList]
                                i.passenger.attachments = [...i.passenger.attachments, ...res.body.uploadAttachList]
                                i.fileSize = res.body.uploadAttachList[0].fileSize
                            }
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })

            console.log(this.vo.passenger.tbItemList, 'this.vo.passenger.tbItemList')
        },
        handleRemove(file, row) {
            this.$http({
                method: 'delete',
                url: '/' + this.baseUrl + '/' + this.module + '/deleteAttach',
                params: {
                    attachIds: file.id
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.updated = false
                    this.$message.success(res.message)
                    this.vo.passenger.tbItemList.forEach((i) => {
                        if (i.id === row.id) {
                            // i.passenger.attachments = []
                            i.passenger.attachments = i.passenger.attachments.filter((item) => item.id !== file.id)
                        }
                    })
                    console.log(this.vo.passenger.tbItemList, 'this.vo.passenger.tbItemList')
                    this.$nextTick(() => {
                        this.updated = true
                    })
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        uploadChange2(row) {
            this.uploadId2 = row.id
        },
        truncateFileName2(fileName) {
            // 这里只是一个简单的示例，你可以根据需要调整逻辑
            const maxLength = 20 // 你可以设置你想要的最大长度
            if (fileName.length > maxLength) {
                return fileName.substring(0, maxLength) + '...'
            }
            return fileName
        },
        fileChange2(files, fileList) {
            if (fileList.length > 0) {
                this.uploadAttach2([files])

                console.log(files, fileList)
            }
        },
        uploadAttach2(fileList) {
            const uploadId = this.uploadId2
            fileList.forEach((item) => {
                const fd = new FormData()
                fd.append('file', item.raw)
                fd.append('module', this.module)
                fd.append('busiDataId', uploadId)
                fd.append('attachsType', '非中标/成交文件')
                fd.append('clientType', 'uploader')
                fd.append('attachsName', item.name)
                this.$http({
                    method: 'post',
                    url: '/' + this.baseUrl + '/' + this.module + '/upload',
                    data: fd
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.vo.passenger.tbItemList.forEach((i) => {
                            debugger
                            if (i.id === uploadId) {
                                // 如果attachments数组还不存在，则创建它
                                if (!i.passenger.attachments) {
                                    this.$set(i.passenger, 'attachments1', [{}])
                                }
                                i.invoiceId = res.body.invoiceId
                                // i.passenger.attachments1 = [...res.body.uploadAttachList]
                                debugger
                                i.passenger.attachments = [...i.passenger.attachments, ...res.body.uploadAttachList]
                                i.fileSize = res.body.uploadAttachList[0].fileSize
                            }
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })

            console.log(this.vo.passenger.tbItemList, 'this.vo.passenger.tbItemList')
        },
        handleRemove2(file, row) {
            this.$http({
                method: 'delete',
                url: '/' + this.baseUrl + '/' + this.module + '/deleteAttach',
                params: {
                    attachIds: file.id
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.updated = false
                    this.$message.success(res.message)
                    this.vo.passenger.tbItemList.forEach((i) => {
                        if (i.id === row.id) {
                            // i.passenger.attachments = []
                            i.passenger.attachments = i.passenger.attachments.filter((item) => item.id !== file.id)
                        }
                    })
                    console.log(this.vo.passenger.tbItemList, 'this.vo.passenger.tbItemList')
                    this.$nextTick(() => {
                        this.updated = true
                    })
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        download(attach) {
            if (attach.id === undefined) return
            window.open(process.env.VUE_APP_BASE_API + '/' + this.baseUrl + '/' + this.module + '/downloadById?inline=true&attachIds=' + attach.id)
        }
    }
}
</script>

<style scoped lang="scss"></style>
